import { useContext, useState } from 'react';
import { AuthContext } from '../../Context/AuthContext';
import useRequestHandler from './../useRequestHandler';

const useReadCompanyPrivacyPolicy = () => {

    const { acquireTokenSilently, apiClient } = useContext(AuthContext);
    const { successHandler } = useRequestHandler();
    const [ companyPrivacyPolicy, setCompanyPrivacyPolicy ] = useState({});

    /** Read company privacy policy */
    const readCompanyPrivacyPolicy = async () => {
        try {

            const accessToken = await acquireTokenSilently();

            if (accessToken === "login_required") throw Error("login_required");

            const result = await apiClient.read(accessToken, "company/privacypolicy");

            setCompanyPrivacyPolicy(result.data);

            return successHandler(result, "useReadCompanyPrivacyPolicy", "read", { hide: true });

        } catch (error) {
        }
    }

    return { companyPrivacyPolicy, setCompanyPrivacyPolicy, readCompanyPrivacyPolicy };

}

export default useReadCompanyPrivacyPolicy;
